var invisibleCaptchaSiteKey = '6LdaScchAAAAAJUR-ZHN7i2U54wgepe8VrZKHDyF';
var visibleCaptchaSiteKey = '6Lfbey8nAAAAAJe3rZPL5cVMlIDPiI0mkYu4fvGG';
export var visibleCaptchaCall = function (htmlElement, callback) {
    var _a;
    (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.ready(function () {
        window.grecaptcha.render(htmlElement, {
            sitekey: visibleCaptchaSiteKey,
            callback: function (captcha) { return callback(captcha); },
            // theme: 'dark',
        });
    });
};
export var invisibleCaptchaCall = function () {
    return new Promise(function (resolve) {
        var _a;
        (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.ready(function () {
            var _a;
            resolve((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.execute(invisibleCaptchaSiteKey, {
                action: 'submit',
            }));
        });
    });
};
var errorMessageForCapthca = 'extendedCaptchaRequired';
export var shouldShowVisibleCaptcha = function (errorMessage) {
    return new Promise(function (resolve, reject) {
        return errorMessage === errorMessageForCapthca ? resolve() : reject(errorMessage);
    });
};
